<template>
<div class="chapter">
<div class="inner_page">
<p class="part11">Please Don’t Eat the Daisies</p>
<p class="author">Jean Kerr</p>
<div class="img_container4">
<img alt="Image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?046416b2